import en from 'vuetify/src/locale/en.ts'
import ru from 'vuetify/src/locale/ru.ts'
export default {
  en: {
    $vuetify: en
  },
  ru: {
    $vuetify: ru
  }
}
